<div class="col-md-12 text-right">
  <div id="action_bar">
    <div class="action-buttons" role="navigation" aria-label="{{t 'secondaryNavigationLabel'}}">
      {{!-- forward and back--}}
      <button class="btn btn-secondary" id="ok_button" data-close="true">{{t 'okButton'}}</button>
      <button class="btn btn-secondary" data-navigate="{{#if navigation.back}}{{navigation.back}}{{else}}back{{/if}}" id="back_button">{{t 'backButton'}}</button>
      <button class="btn btn-secondary {{#if nextDisabled}}disabled{{/if}}" data-navigate="{{#if navigation.forward}}{{navigation.forward}}{{else}}forward{{/if}}" id="forward_button" data-trigger="manual" data-toggle="popover"
              data-container="body" data-placement="top" data-content="{{t 'forwardPopover'}}" {{#if nextDisabled}}aria-disabled="disabled" disabled{{/if}}>{{t 'forwardButton'}}</button>
    </div>

    {{!-- <button class="btn btn-secondary" >Home</button> --}}
    <button data-navigate="home" id="home_button" class="btn btn-secondary">{{t 'home'}}</button>

    {{!-- show/hide narration --}}
    <button class="btn btn-secondary actionbar-buttons {{media_status}}" id="narration_toggle" {{#if disable_narration_toggle}}disabled{{/if}}>{{#if showNarration}}{{t 'hideNarration'}}{{else}}{{t 'showNarration'}}{{/if}}</button>
    <span id="narration" {{#unless showNarration}}style="display:none;" {{/unless}} tabindex="0">{{narrationText}}</span>
    {{#if localeSwitcher}}
      <select class="form-control" id="locale-switcher" >
        {{#each languages}}
          <option value="{{this}}" {{#if (equal this ../language)}}selected{{/if}}>{{t (concat 'languages.' this) }}</option>
        {{/each}}
      </select>
    {{/if}}
    {{!-- play button may also become pause and maybe replay as well --}}
    <button class="btn btn-secondary actionbar-buttons {{media_status}}" {{#unless mediaId}}disabled{{/unless}} id="play_button" {{#if disable_play_button}}disabled{{/if}}>{{media_status_text}}</button>
    {{!-- mute and unmute --}}
    <button class="btn btn-secondary actionbar-buttons {{#if mute}}mute-on{{else}}mute-off{{/if}}" id="mute_button" {{#if disable_mute_button}}disabled{{/if}}
            {{#unless mediaId}}disabled{{/unless}}
            data-mute-off-text="{{t 'muteOff'}}" data-mute-on-text="{{t 'muteOn'}}"
            data-mute-state="{{#if mute}}on{{else}}off{{/if}}">{{#if mute}}{{t 'muteOn'}}{{else}}{{t 'muteOff'}}{{/if}}</button>

    {{!-- skip, for testing --}}
    <!--<button class="btn btn-secondary" data-back id="skip_button">Skip</button>-->
    <div class="breadcrumbs">
      <span class="home">
        <a href="#menu">{{t 'home'}}</a>
      </span>
      <span class="group">
        {{t groupTitle}}
      </span>
      <span class="module">
        {{t moduleTitle}}
      </span>
      <span class="page">
        {{t pageTitle}}
      </span>
    </div>
    <div class="progress">
      {{!-- Note: Set a min-width on .progress-bar, so the pagesCompleted/totalPages numbers remain legible --}}
      <div class="progress-bar" role="progressbar" style="width:{{pageProgress.progressPercentage}}%;" aria-valuenow="{{pageProgress.progressPercentage}}" aria-valuemin="0" aria-valuemax="100">
        <div class="steps-completed">{{pageProgress.pagesCompleted}}/{{pageProgress.totalPages}}</div>
      </div>
    </div>

  </div>
</div>
